import React from 'react'
import PropTypes from 'prop-types'
import { AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES, SCORE_IDS } from '../../data/constants'
import { getDomainScore } from '../../data/reportModel'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import WhyThisMatters from '../../components/WhyThisMatters/WhyThisMatters'
import GroupGovernance from './GroupGovernance'
import GuestAccess from './GuestAccess'
import SensitivityDlp from './SensitivityDlp'
import SharePoint from './SharePoint'

export default function DataExposure({ summary = {}, data = {}, domainScores = [], dataAvailability = [] }) {
  return (
    <>
      <div {...AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES}>
        <SectionHeading
          id="data-exposure"
          titleId="AI_RISK_REPORT.SECTION.DATA_EXPOSURE.TITLE"
          questionId="AI_RISK_REPORT.SECTION.DATA_EXPOSURE.QUESTION"
        />
        <WhyThisMatters bodyId="AI_RISK_REPORT.SECTION.DATA_EXPOSURE.WHY" />
      </div>
      <SharePoint
        tenantSettings={data.sharePointTenantSettings ?? []}
        dlpPolicies={data.dlpPolicies ?? []}
        score={getDomainScore(domainScores, SCORE_IDS.COPILOT_DATA_EXPOSURE)}
        dataAvailability={dataAvailability}
      />
      <SensitivityDlp
        summary={summary}
        sensitivityLabels={data.sensitivityLabels ?? []}
        dlpPolicies={data.dlpPolicies ?? []}
        score={getDomainScore(domainScores, SCORE_IDS.DATA_GOVERNANCE)}
        dataAvailability={dataAvailability}
      />
      <GroupGovernance
        summary={summary}
        tenant={data.tenant}
        dynamicGroups={data.dynamicGroups ?? []}
        score={getDomainScore(domainScores, SCORE_IDS.GROUP_GOVERNANCE)}
        dataAvailability={dataAvailability}
      />
      <GuestAccess summary={summary} guests={data.guestUsers ?? []} dataAvailability={dataAvailability} />
    </>
  )
}

const summaryPropType = PropTypes.shape({
  groups: PropTypes.shape({
    total: PropTypes.number,
    microsoft365: PropTypes.number,
    dynamic: PropTypes.number,
    dynamicWithMembershipRules: PropTypes.number,
    dynamicCanIncludeGuests: PropTypes.number,
  }),
  users: PropTypes.shape({
    total: PropTypes.number,
    guests: PropTypes.shape({ total: PropTypes.number, pending: PropTypes.number, accepted: PropTypes.number }),
  }),
})

DataExposure.propTypes = {
  summary: summaryPropType,
  data: PropTypes.shape({
    tenant: PropTypes.shape({}),
    sharePointTenantSettings: PropTypes.arrayOf(PropTypes.shape({})),
    sensitivityLabels: PropTypes.arrayOf(PropTypes.shape({})),
    dlpPolicies: PropTypes.arrayOf(PropTypes.shape({})),
    dynamicGroups: PropTypes.arrayOf(PropTypes.shape({})),
    guestUsers: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  domainScores: PropTypes.arrayOf(PropTypes.shape({})),
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
}
